module.exports = __webpack_public_path__ + "img/189.db79fa63.jpg";